import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { OnboardValidation } from 'uplisting-frontend/validations';

export default class OnboardRepositoryService extends BaseRepositoryService<
  ModelRegistry['onboard']
> {
  recordName = 'onboard';
  implementMethods = ['buildChangeset', 'createRecord'];

  validation = OnboardValidation;

  get defaultParams() {
    return {
      id: 'me',
    };
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/onboard': OnboardRepositoryService;
  }
}
